import React from 'react';
import useStyle from './tableExplanation.style';

interface textExplanationsProps {
  textExplanations: {
    id: string;
    title: string;
    content: string;
  }[];
}

const TableExplanations = ({ textExplanations }: textExplanationsProps) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      {textExplanations.map(text => (
        <div key={text.id}>
          <p className={classes.bold}>{text.title} :</p>
          <p>{text.content}</p>
        </div>
      ))}
    </div>
  );
};

export default TableExplanations;
